module.exports = __webpack_public_path__ + "img/RadectHealthLogoLarge.11159fe0.svg";